/**
 * @file CaptionPresetField.tsx
 * @description Стиль надписи — основа [КАПСОМ][Акцентом] у «Надписи» и
 * надписей на фото (phase19.16, партия SB120, этап 3а; uiux-sb120-stage3 §3;
 * данные db-design-sb120-stage3 §2 `preset`). Капсом — шрифтом надписей,
 * 700, 14 px, разрядка темы; акцентом — шрифтом акцента, 24 px. Шрифт,
 * размер и цвет поверх основы — части `typo`. Подписи — из shared.
 */

import { CAPTION_PRESETS, CAPTION_PRESET_LABELS, type CaptionPreset } from "@chaiberi/shared";

import { Label } from "../../../ui/label";
import { Segmented, type SegmentedOption } from "../../../site-view/Segmented";

/** Варианты: капсом — образцом прописными (имя для чтеца — обычными). */
export const CAPTION_PRESET_OPTIONS: readonly SegmentedOption<CaptionPreset>[] = CAPTION_PRESETS.map((value) => ({
  value,
  ariaLabel: CAPTION_PRESET_LABELS[value],
  label: value === "caps" ? CAPTION_PRESET_LABELS[value].toUpperCase() : CAPTION_PRESET_LABELS[value],
}));

export const CAPTION_PRESET_HINT = "Основа надписи. Шрифт, размер и цвет поверх неё — в «Цвете и шрифте».";

export function CaptionPresetField({ value, onChange, hint = CAPTION_PRESET_HINT }: { value: CaptionPreset; onChange: (preset: CaptionPreset) => void; hint?: string | null }) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <Label>Стиль</Label>
      <Segmented aria-label="Стиль надписи" options={CAPTION_PRESET_OPTIONS} value={value} onChange={onChange} />
      {hint ? <p className="type-caption text-on-surface-variant">{hint}</p> : null}
    </div>
  );
}
